module.exports = __webpack_public_path__ + "img/logo-dark.9525dae5.svg";